var fp,
fullpage = {
	settings: {
		fullPage: $('#fullpage'),
	},
	init: function() {
		fp = this.settings;
		this.bindUIActions();
		console.log('fullpage loaded!');
	},
	bindUIActions: function() {
		fp.fullPage.fullpage( {
		    licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
		    // v2compatible: 'true',
		    controlArrows: false,
		    autoScrolling: true,
		    scrollOverflow: true,
		    slidesNavigation: true,
			slidesNavPosition: 'left',
		    scrollHorizontally: true,
		    scrollHorizontallyKey: 'YWxjYmV2dGVzdGluZy5jb21fNDRVYzJOeWIyeHNTRzl5YVhwdmJuUmhiR3g1ZEEz',
		    offsetSections: true,
		    offsetSectionsKey: 'YWxjYmV2dGVzdGluZy5jb21fMkc0YjJabWMyVjBVMlZqZEdsdmJuTT14RXQ=',
		});
	}
};
